import LayoutPage from "../../Components/LayoutPage"
import NavLayer2 from "../../Components/NavLayer2/NavLayer2"
import Container from "./Components/Container"

const RulesWithdraw = [
  {question: "پرداخت و تقسیم سود ",
    answer: (
      <div>
        <p>سهم معامله‌گر از سود حاصله (Profit Split) در کوژیتو فاند از ۸۰٪ تا سقف ۹۰٪ قابل افزایش است. کلیه پرداخت‌ها از طریق ارز دیجیتال تتر (USDT) انجام می‌شود.</p>
        <p>معامله‌گر می‌تواند اولین برداشت سود خود را ۱۴ روز پس از اولین ترید در حساب اصلی (Funded Account) درخواست کند. پس از آن، سیکل‌های برداشت به صورت دوهفته‌یک‌بار خواهد بود. وجوه ارسالی در کمتر از ۲۴ ساعت به کیف پول شما واریز می‌گردد.</p>
      </div>
    ),
  },
  {question: "سیاست بازپرداخت ۱۲۰٪ (Refund)",
    answer: "در کوژیتو، ما به معامله‌گران موفق پاداش می‌دهیم. پس از گذراندن مراحل ارزیابی و تثبیت، در زمان اولین برداشت سود از حساب، ۱۲۰٪هزینه اولیه چالش به شما بازگردانده می‌شود.",
  },
]

export default function NotificationAll() {
  return (
    <LayoutPage activeIndex={15} navItems={["قوانین"]} childrenClassName="flex-1 min-h-0 flex flex-col gap-5">
      <NavLayer2 texts={["عمومی" , "چالش‌ها", "برداشت", "دعوت از دوستان"]} hrefs={["/rule/general" , "/rule/challenge", "/rule/withdraw", "/rule/invite"]} activeIndex={2}/>
      <div className="w-full h-fit flex flex-col items-center gap-5 min-h-0 overflow-y-auto">
        <Container items={RulesWithdraw}/>
      </div>
    </LayoutPage>
  )
}